// extracted by mini-css-extract-plugin
export default {"container":"Category_container__d4uYO","body":"Category_body__foxMN"};